import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { hasPermission } from "../hooks/useCan";
import { WhatsAppScreen } from "../components/whatsapp/WhatsAppScreen";

const searchSchema = z.object({
  tab: z.enum(["chats", "templates", "numbers"]).optional(),
  // The open chat. In the address so a chat can be opened in a new tab.
  c: z.string().optional(),
  view: z.enum(["all", "mine", "unread"]).optional(),
  q: z.string().optional(),
  // The chat list's number filter: "main" or a connected number's id.
  n: z.string().optional(),
});

export const Route = createFileRoute("/_auth/whatsapp")({
  staticData: { titleKey: "nav.whatsapp", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  validateSearch: searchSchema,
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (!me) return;
    if (!hasPermission(me, "use_whatsapp")) {
      throw redirect({ to: "/clients" });
    }
  },
  component: WhatsAppRoute,
});

function WhatsAppRoute() {
  return <WhatsAppScreen search={Route.useSearch()} />;
}
